module.exports = __webpack_public_path__ + "images/confluence-crossflow/illustration.238a963919c196a9b296.png";